import { message } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload';
import { RcFile, UploadFile } from 'antd/lib/upload/interface';
import { makeAutoObservable, runInAction } from 'mobx';
import Subjects from '../../models/subjects';
import { TaskService } from '../../services/task-service';

export default class ImageUploaderStore {

    inactive: boolean;
    taskId: number | null;
    url: string;
    files: UploadFile[] | [];
    loading: boolean;
    isMainPhoto: boolean;
    subject: Subjects;
    taskService: TaskService;

    constructor(subject: Subjects, isMainPhoto: boolean) {
        this.inactive = true;
        this.subject = subject;
        this.taskId = null;
        this.url = "";
        this.taskService = new TaskService();
        this.isMainPhoto = isMainPhoto;
        this.files = [];
        this.loading = false;
        makeAutoObservable(this);
    }

    reset() {
        this.inactive = true;
        this.taskId = null;
        this.url = "";
        this.files = [];
    }

    changeActivated(active: boolean) {
        this.inactive = !active;
    }

    setTaskId(taskId: number) {
        this.taskId = taskId;
        this.url = this.getUrl(taskId);
    }

    setFile(newFile: UploadFile) {
        if (!this.inactive) {
            this.files = [...this.files, newFile];
        }
    }

    setFiles(newFiles: UploadFile[]) {
        if (!this.inactive) {
            this.files = newFiles;
        }
    }

    handleOnChange(info: UploadChangeParam<UploadFile<any>>, callback?: () => any) {

        runInAction(() => {
            const { status } = info.file;

            if (status === 'done') {
                message.success(`${info.file.name} успешно загружен`);
                if (callback) {
                    callback();
                }
            } else if (status === 'error') {
                message.error(`Во время загрузки файла ${info.file.name} произошла ошибка`);
            }
            this.files = info.fileList;
        });
    }

    getUrl(taskId: number): string {

        if (this.subject === Subjects.MATH) {
            return this.taskService.getPhotoUploadUrl(taskId, this.isMainPhoto);
        }

        return "";
    }

    handleManualUpload(newFile: UploadFile, onLoadAction?: () => any) {

        if (!this.inactive && this.taskId) {

            this.loading = true;

            this.taskService
                .loadPhoto(newFile.originFileObj as RcFile, this.isMainPhoto, this.taskId,
                    () => {

                        message.success(`${newFile.name} успешно загружен`);

                        this.files = [...this.files, newFile];
                        this.loading = false;

                        if (onLoadAction) {
                            runInAction(() => onLoadAction());
                        }
                    },
                    (_) => {
                        message.error(`Во время загрузки файла ${newFile.name} произошла ошибка`);
                        this.loading = false;
                    }
                );
        }
    }
}